export default {
  loading(state) {
    return state.Loading;
  },
  data(state) {
    return state.data;
  },
};
